var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "hoverfill",
    cx: 25,
    cy: 25,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "content",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2511 15.2884C36.8894 15.4641 37.4715 15.8106 37.9385 16.2929C38.4057 16.7751 38.7414 17.376 38.9116 18.0349C39.3677 20.5022 39.5925 23.0091 39.5826 25.521C39.5976 28.0389 39.3888 30.5529 38.9586 33.0314C38.7888 33.7024 38.4481 34.3142 37.9721 34.8036C37.4959 35.2929 36.9018 35.6419 36.2511 35.8144C33.8968 36.4585 24.4793 36.4585 24.4793 36.4585C24.4793 36.4585 15.0618 36.4585 12.7074 35.7901C12.0609 35.6207 11.4697 35.2771 10.9941 34.7946C10.5183 34.312 10.1752 33.7078 9.99983 33.0436C9.5682 30.5612 9.35934 28.043 9.37591 25.521C9.36099 23.0071 9.56984 20.4971 9.99983 18.0228C10.1789 17.3591 10.523 16.7553 10.9979 16.2714C11.4729 15.7875 12.0622 15.4402 12.7074 15.264C15.0618 14.5835 24.4793 14.5835 24.4793 14.5835C24.4793 14.5835 33.8968 14.5835 36.2511 15.2884ZM29.3293 25.521L21.4656 30.1999V20.8665L29.3293 25.521Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7816a7c2c285051134ff9ff3735b1a26.svg";
export { ForwardRef as ReactComponent };